import { Grid, Box } from '@mui/material'
import FrequencyCard from './FrequencyCard'
import GoogleIcon from '../../../../components/icon/GoogleIcon'
import dayjs from '../../../../utils/dayjsConfig'
import { formatMoney } from '../../../../helpers/utils'

import {
  FREQUENCY_CARDS,
  FREQUENCY_CARD_STYLES,
  FREQUENCY_STATUS_COLORS
} from '../../constants/ClientDashboardConst'

export default function FrequencySummary({ cardInfo }) {
  const daysFromLastOrder = cardInfo.last_order_date
    ? dayjs().diff(dayjs(cardInfo.last_order_date), 'day')
    : null

  const frequencyValues = {
    lastOrderDate: cardInfo.last_order_date
      ? dayjs(cardInfo.last_order_date, 'YYYY-MM-DD').format('M/DD/YYYY')
      : '—',

    daysFromLastOrder: daysFromLastOrder != null ? `${daysFromLastOrder} días` : '—',

    ordersCount: cardInfo.total_orders_count ?? '—',

    averageTicket:
      cardInfo.average_order_amount != null ? formatMoney(cardInfo.average_order_amount) : '—'
  }

  const statusColor =
    daysFromLastOrder <= 7
      ? FREQUENCY_STATUS_COLORS.good
      : daysFromLastOrder <= 21
        ? FREQUENCY_STATUS_COLORS.warning
        : FREQUENCY_STATUS_COLORS.danger

  return (
    <Box>
      <Grid container spacing={2}>
        {FREQUENCY_CARDS.map((card) => (
          <Grid key={card.key} item xs={12} sm={6} md={2.4}>
            <FrequencyCard
              title={card.title}
              value={frequencyValues[card.key]}
              icon={<GoogleIcon name={card.icon} filled size={20} />}
              valueColor={
                card.key === 'daysFromLastOrder' ? statusColor : FREQUENCY_CARD_STYLES.valueColor
              }
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
